<div class="progress-row green">
    <svg class="circular-progress" viewBox="0 0 36 36">
        <!-- Background circle -->
        <path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <!-- Progress circle -->
        <path class="circle" [attr.stroke-dasharray]="(value / number * 100) + ', 100'"
            d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
        <!-- Text in the center -->
        <text x="18" y="21.35" class="percentage">
            {{ isNumber ? value + '/' + number : value + '%' }}
        </text>
    </svg>
    <div class="progress-text">{{title}}</div>
</div>
